module.exports = __webpack_public_path__ + "static/media/grid-item-a14.2474ee0c.png";